import { NgModule } from '@angular/core';
import { ShareCertificateIframeModule } from '../components/share-certificate-iframe/share-certificate-iframe.component';
import { ActivityCalendarModule } from '../activity-calendar/activity-calendar.module';
import { ActivityRegistryModule } from '../activity-registry/activity-registry.module';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { SharedModule } from '../shared/shared.module';
import { TeacherFeedbackModule } from '../teacher-feedback/teacher-feedback.module';
import { TestResultsModule } from '../test-results/test-results.module';
import { ActiveTicketComponent } from './active-ticket/active-ticket.component';
import { BadgesSectionComponent } from './badges-section/badges-section.component';
import { CertificatesSectionComponent } from './certificates-section/certificates-section.component';
import { ErrorTicketComponent } from './error-ticket/error-ticket.component';
import { InactiveTicketComponent } from './inactive-ticket/inactive-ticket.component';
import { InitialTicketComponent } from './initial-ticket/initial-ticket.component';
import { ProgressPageLeaderboardsComponent } from './progress-page-leaderboards/progress-page-leaderboards.component';
import { ProgressPageProgressSectionComponent } from './progress-page-progress-section/progress-page-progress-section.component';
import { ProgressPageComponent } from './progress-page/progress-page.component';
import { ShareCertificateComponent } from './share-certificate/share-certificate.component';
import { ProfileAvatarModule } from '../components/profile-avatar/profile-avatar.component';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  entryComponents: [
    ShareCertificateComponent,
  ],
  declarations: [
    ProgressPageComponent,
    InitialTicketComponent,
    ActiveTicketComponent,
    InactiveTicketComponent,
    BadgesSectionComponent,
    ErrorTicketComponent,
    CertificatesSectionComponent,
    ProgressPageLeaderboardsComponent,
    ProgressPageProgressSectionComponent,
    ShareCertificateComponent
  ],
  imports: [
    ActivityRegistryModule,
    SharedModule,
    TeacherFeedbackModule,
    ActivityCalendarModule,
    TestResultsModule,
    SafeUrlPipeModule,
    ShareCertificateIframeModule,
    ProfileAvatarModule,
    UserwaySyncModule
  ],
})
export class ProgressModule {}



// WEBPACK FOOTER //
// ./ts/app/progress/progress.module.ts